import React from 'react';
//import PropTypes from 'prop-types';
import {
    Row, Col
} from 'antd';
import './Header.css';
import { request } from './service';
import { urlHeaderData } from '../config';

const monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni",
    "Juli", "Agustus", "September", "Oktober", "Nopember", "Desember"
];

const dayNames = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"];


class Header extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            header: '',
            subheader: '',
            date: '',
            time: '',
            logo: ''
        }
    }

    timer = () => {
        this.setState({
            time: this.setJam(),
            date: this.setDate()
        });
    }

    componentDidMount() {
        const logo = localStorage.getItem('logoRsBase64');
        this.setState({
            time: this.setJam(),
            date: this.setDate(),
            logo: logo
        })
        this.intervalId = setInterval(this.timer.bind(this), 60000);
        this.setData();
    }

    setData = async () => {
        const url = urlHeaderData;
        const response = await request(url);
        if(typeof response.header != 'undefined'){
            this.setState(response);
        }        
    }

    getInfoKamar = () => {

    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    setDate = () => {
        var d = new Date();
        return dayNames[d.getDay()-1] + ', ' + this.addZero(d.getDate()) + ' ' + monthNames[d.getMonth()] + ' ' + d.getFullYear();
    }

    addZero = (i) => {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }

    setJam = () => {

        var d = new Date();
        var h = d.getHours();
        var m = d.getMinutes();

        return h + ':' + this.addZero(m);
    }

    render() {
        const { header, subheader } = this.state;
        return (
            <div>
                <p></p>
                <Row type="flex" align="middle">
                    <Col span={2}>
                        <Row type="flex" justify="space-around" align="middle">
                            <Col>
                                <img
                                    alt={"logo"}
                                    className="img-header"
                                    style={{
                                        height: 60,
                                        width: 50,
                                        backgroundColor: "grey"
                                    }}
                                    src={this.state.logo}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={15}>
                        <Row type="flex" justify="start" align="middle">
                            <Col>
                                <div className="title-header">{header}</div>
                                <div className="subtitle-header">{subheader}</div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={7}>
                        <Row type="flex" justify="center" align="middle">
                            <Col>
                                <div className="date-header">{this.state.date}</div>
                                <div className="hour-header" align="center">{this.state.time}</div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default Header;